import React, { useEffect } from 'react';
import AuthLayout from '../components/AuthLayout';

// 환경에 따른 API_BASE_URL 설정
let API_BASE_URL;
if (process.env.NODE_ENV === 'production') {
  API_BASE_URL = window.location.origin;
} else {
  API_BASE_URL = 'http://localhost:3001';
}

export default function CertSelect() {
  // 팝업 환경에서 스크롤 제거
  useEffect(() => {
    // 팝업 환경인지 확인 (URL에 popup2가 포함되어 있거나 팝업 창인 경우)
    const isPopup = window.location.pathname.includes('popup2') || window.opener;

    if (isPopup) {
      // 팝업 환경에서만 스크롤 제거
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      // 컴포넌트 언마운트 시 스크롤 복원
      return () => {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      };
    }
  }, []);

  // console.log('[CertSelect] 컴포넌트 마운트 시작');
  // console.log('[CertSelect] 현재 URL:', window.location.href);
  // console.log('[CertSelect] window.location.search:', window.location.search);
  // console.log('[CertSelect] API_BASE_URL:', API_BASE_URL);
  // console.log('[CertSelect] window.location.origin:', window.location.origin);
  // console.log('[CertSelect] NODE_ENV:', process.env.NODE_ENV);

  // URL 파라미터에서 authType과 userIndex 추출
  const urlParams = new URLSearchParams(window.location.search);
  const authType = urlParams.get('authType');
  const userIndex = urlParams.get('userIndex');
  const redirectUrl = urlParams.get('redirectUrl');
  const origin = urlParams.get('origin');

  // console.log('[CertSelect] URL 파라미터:', {
  //   authType,
  //   userIndex,
  //   redirectUrl,
  //   origin,
  //   allParams: Object.fromEntries(urlParams.entries())
  // });

  // 팝업에 전달된 쿼리 파라미터 유지
  const params = window.location.search;

  // 실제 API 서버 주소
  const apiServer = API_BASE_URL;
  // 더 간단하고 정확한 origin
  const currentOrigin = window.location.origin;
  const kcbRedirectUrl = redirectUrl || `${currentOrigin}/cert/kcb/popup3`;
  const raonRedirectUrl = `${currentOrigin}/cert/raon/result`;

  // authType과 userIndex 파라미터 추가
  const additionalParams = authType ? `&authType=${authType}` : '';
  const userIndexParam = userIndex ? `&userIndex=${userIndex}` : '';

  const kcbPopup2Params = `?view=web&redirectUrl=${encodeURIComponent(kcbRedirectUrl)}&origin=${encodeURIComponent(origin || currentOrigin)}${additionalParams}${userIndexParam}`;
  const raonPopup2Params = `?view=web&callbackUrl=${encodeURIComponent(raonRedirectUrl)}&origin=${encodeURIComponent(origin || currentOrigin)}${additionalParams}${userIndexParam}`;

  // console.log('[CertSelect] 생성된 파라미터:', {
  //   kcbPopup2Params,
  //   raonPopup2Params,
  //   apiServer,
  //   kcbRedirectUrl,
  //   raonRedirectUrl
  // });

  const goKcb = () => {
    // console.log('[CertSelect] goKcb 함수 호출됨');
    try {
      const popupUrl = `${apiServer}/cert/kcb/popup2${kcbPopup2Params}`;
      // console.log('[KCB DEBUG] goKcb 이동 URL:', popupUrl);
      // console.log('[KCB DEBUG] origin:', origin || currentOrigin);
      // console.log('[KCB DEBUG] redirectUrl:', kcbRedirectUrl);
      // console.log('[KCB DEBUG] authType:', authType);
      // console.log('[KCB DEBUG] userIndex:', userIndex);
      window.location.href = popupUrl;
    } catch (err) {
      // console.error('[KCB ERROR] goKcb 이동 중 오류:', err);
    }
  };

  const goRaon = () => {
    // console.log('[CertSelect] goRaon 함수 호출됨');
    try {
      // 간편인증 URL로 이동
      const popupUrl = `${apiServer}/cert/raon/popup${raonPopup2Params}`;
      // console.log('[RAON DEBUG] goRaon 이동 URL:', popupUrl);
      // console.log('[RAON DEBUG] origin:', origin || currentOrigin);
      // console.log('[RAON DEBUG] redirectUrl:', raonRedirectUrl);
      // console.log('[RAON DEBUG] authType:', authType);
      // console.log('[RAON DEBUG] userIndex:', userIndex);
      window.open(popupUrl, 'raon_popup', 'width=430,height=640,scrollbars=yes,resizable=yes');
      // console.log('[RAON DEBUG] goRaon 클릭됨');
    } catch (err) {
      // console.error('[RAON ERROR] goRaon 이동 중 오류:', err);
    }
  };

  // console.log('[CertSelect] 컴포넌트 렌더링 시작');

  // 팝업 환경인지 확인
  const isPopup = window.location.pathname.includes('popup2') || window.opener;

  return (
    <AuthLayout popup title="인증 방식을 선택하세요" description="원하는 방식을 고르면 인증 화면으로 넘어가요.">
      <div className="auth-page__methods">
        <button type="button" className="auth-page__method" onClick={goKcb}>
          <img src="/img/pass.png" alt="" aria-hidden="true" />
          <span>휴대폰 본인인증</span>
        </button>
        <button type="button" className="auth-page__method" onClick={goRaon}>
          <img src="/img/Group.png" alt="" aria-hidden="true" />
          <span>간편인증</span>
        </button>
      </div>
    </AuthLayout>
  );
} 